type IconProps = React.SVGProps<SVGSVGElement>;

const EyeOpen: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.37451C3.75 4.37451 1.25 10.0001 1.25 10.0001C1.25 10.0001 3.75 15.6245 10 15.6245C16.25 15.6245 18.75 10.0001 18.75 10.0001C18.75 10.0001 16.25 4.37451 10 4.37451Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 13.1252C11.7259 13.1252 13.125 11.7261 13.125 10.0002C13.125 8.27428 11.7259 6.87517 10 6.87517C8.27411 6.87517 6.875 8.27428 6.875 10.0002C6.875 11.7261 8.27411 13.1252 10 13.1252Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EyeOpen;
